import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { PRACTICE_SETTINGS_USER_ROLES } from "api/Service";

export const USER_ROLES_QUERY_KEY = "userRoles";

export const useUserRoles = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: [USER_ROLES_QUERY_KEY, tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${PRACTICE_SETTINGS_USER_ROLES}`
      );

      return Array.isArray(response.data) ? response.data : [];
    },
    enabled: !!tenantVal,
    staleTime: 5 * 60 * 1000,
  });
};
